export default __webpack_public_path__ + "static/bl-26d9d9accb84b3f873a63c9e99e7780b.svg";